import React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";

const StyledOverlay = styled.div`
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background-color: rgba(0, 0, 0, 0.7);
  cursor: pointer;
`;

const Modal = ({ children, isModalOpen, setIsModalOpen }) => {
  return createPortal(
    <>
      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: "easeInOut", duration: 0.2 }}
          >
            <StyledOverlay
              onClick={() => {
                setIsModalOpen(false);
              }}
            />

            {children}
          </motion.div>
        )}
      </AnimatePresence>
      ,
    </>,
    document.getElementById("modal")
  );
};

export default Modal;
